import { action, observable } from 'mobx';
import Breakpoints from 'breakpoints-js/dist/breakpoints';
import API from '../api';

export interface modalSettings {
	message: string;
	timeout: number;
	showLoader: boolean;
	closeIcon: boolean;
	size: string;
	isActive: boolean;
	isModal: boolean;
	header: any;
	actions: Array<any>;
	config: 'info' | 'error' | '';
	onClose: () => {};
	timeoutCallback: () => {};
}

export default class UiShared {
	rootStore = null;
	breakpoints = null;

	constructor(rootStore) {
		let self = this;
		this.rootStore = rootStore;
		this.breakpoints = new Breakpoints();
		this.size = Breakpoints.current().name;
		Breakpoints.on('change', function() {
			self.setSize(this.current.name);
		});
		API.get('/Rxes/enabledWip').then(res => {
			if (res.enabledWip === true) {
				this.enabledWip = true;
			}
		});
	}

	@observable
	modal = {
		message: '',
		showLoader: false,
		timeout: -1,
		isActive: false,
		isModal: true,
		closeIcon: false,
		size: 'mini',
		header: null,
		actions: [],
		config: '',
		onClose: () => (this.modal.isActive = false),
		timeoutCallback: () => {}
	};
	@observable size: string = '';
	@observable wipEnabled: boolean = false;
	@observable prodaInit: boolean = false;
	@observable redirectProda: boolean = false;

	@action
	showModal(arg1: string | modalSettings, arg2?: modalSettings) {
		let message = typeof arg1 === 'string' ? arg1 : '';
		let settings = typeof arg1 === 'object' ? arg1 : arg2;
		settings = {
			...{
				timeout: -1,
				showLoader: false,
				closeIcon: false,
				size: 'mini',
				isActive: true,
				isModal: true,
				onClose: () => {
					if (!this.modal.isModal) {
						this.modal.isActive = false;
					}
				},
				timeoutCallback: () => {},
				message: message,
				header: null,
				actions: []
			},
			...settings
		};
		this.modal = settings;
		if (settings.timeout > 0) {
			setTimeout(() => {
				this.modal.isActive = false;
				this.modal.timeout = -1;
				settings.timeoutCallback && settings.timeoutCallback();
			}, settings.timeout);
		}
	}

	@action
	showSpinner(message: ?string) {
		this.modal = {
			timeout: -1,
			showLoader: true,
			closeIcon: false,
			size: 'mini',
			isActive: true,
			isModal: true,
			onClose: () => (this.modal.isActive = false),
			timeoutCallback: () => {},
			message: message,
			header: null,
			actions: []
		};
	}

	@action
	hideModal(force: boolean = false) {
		if (this.modal.isActive && this.modal.timeout > -1 && !force) {
			return;
		}
		this.modal.isActive = false;
	}

	@action
	setSize(newSize: string) {
		this.size = newSize;
	}
}



// WEBPACK FOOTER //
// ./src/stores/UiShared.js